











import { Component, Vue, Prop } from "vue-property-decorator"

@Component
export default class HealthCheckSummaryBodyMapSeverityLevel extends Vue {
  @Prop() readonly items!: string[]
  @Prop() readonly info!: string
}
